// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-screen-vacation {
  position: absolute;
  left: 15%;
  top: 0;
  width: 85%;
  height: 100%;
  background-color: #f5f5f5;
}
@media (max-width: 768px) {
  .main-screen-vacation {
    left: 0;
    width: 100%;
    top: 55px;
    /* Adjust based on the height of the hamburger menu */
  }
}

.main-screen-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 15%;
  height: 100%;
  background-color: #1c1c1c;
  color: white;
}
@media (max-width: 768px) {
  .main-screen-header {
    width: 100%;
    height: 55px;
    /* Adjust as needed for the hamburger menu height */
    z-index: 1001;
  }
}

.modal-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: #f5f5f5;
  box-shadow: 24px;
  padding: 40px;
  border-radius: 12px;
}

.modal-title {
  font-weight: bold;
  text-align: center;
  color: #333;
  padding-bottom: 1rem;
}

.preview-section {
  margin-bottom: 1.5rem;
  text-align: center;
}
.preview-section .preview-text {
  font-size: 1rem;
  color: #666;
}

.text-field {
  margin-bottom: 1.5rem;
}
.text-field .MuiOutlinedInput-root fieldset {
  border-color: #ccc;
}
.text-field .MuiOutlinedInput-root:hover fieldset {
  border-color: #888;
}
.text-field .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: #1976d2;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
}
.modal-actions .cancel-button {
  color: #555;
  text-transform: none;
}
.modal-actions .save-button {
  background-color: #1976d2;
  color: #fff;
  border-radius: 8px;
  padding: 8px 16px;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
  text-transform: none;
}
.modal-actions .save-button:hover {
  background-color: #145ca4;
}`, "",{"version":3,"sources":["webpack://./src/screens/main/styles/index.scss"],"names":[],"mappings":"AAOA;EACI,kBAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AANJ;AAOI;EAPJ;IAQQ,OAAA;IACA,WAAA;IACA,SAAA;IACA,qDAAA;EAJN;AACF;;AAOA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AAJJ;AAKI;EARJ;IASQ,WAAA;IACA,YAAA;IACA,mDAAA;IACA,aAAA;EAFN;AACF;;AAKA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,yBAxCe;EAyCf,gBAAA;EACA,aAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,kBAAA;EACA,WApDc;EAqDd,oBAAA;AAFJ;;AAKA;EACI,qBAAA;EACA,kBAAA;AAFJ;AAGI;EACI,eAAA;EACA,WAAA;AADR;;AAKA;EACI,qBAAA;AAFJ;AAIQ;EACI,kBApEC;AAkEb;AAIQ;EACI,kBAtEA;AAoEZ;AAIQ;EACI,qBA5EI;AA0EhB;;AAOA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;AAKI;EACI,WAAA;EACA,oBAAA;AAHR;AAKI;EACI,yBA3FQ;EA4FR,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,0CAAA;EACA,oBAAA;AAHR;AAIQ;EACI,yBAAA;AAFZ","sourcesContent":["$primary-color: #1976d2;\n$secondary-color: #333;\n$light-gray: #ccc;\n$dark-gray: #888;\n$background-color: #f5f5f5;\n$mobile: 480px;\n$tablet: 768px;\n.main-screen-vacation {\n    position: absolute;\n    left: 15%;\n    top: 0;\n    width: 85%;\n    height: 100%;\n    background-color: #f5f5f5;\n    @media (max-width: $tablet) {\n        left: 0;\n        width: 100%;\n        top: 55px;\n        /* Adjust based on the height of the hamburger menu */\n    }\n}\n\n.main-screen-header {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 15%;\n    height: 100%;\n    background-color: #1c1c1c;\n    color: white;\n    @media (max-width: $tablet) {\n        width: 100%;\n        height: 55px;\n        /* Adjust as needed for the hamburger menu height */\n        z-index: 1001;\n    }\n}\n\n.modal-container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 400px;\n    background-color: $background-color;\n    box-shadow: 24px;\n    padding: 40px;\n    border-radius: 12px;\n}\n\n.modal-title {\n    font-weight: bold;\n    text-align: center;\n    color: $secondary-color;\n    padding-bottom: 1rem;\n}\n\n.preview-section {\n    margin-bottom: 1.5rem;\n    text-align: center;\n    .preview-text {\n        font-size: 1rem;\n        color: #666;\n    }\n}\n\n.text-field {\n    margin-bottom: 1.5rem;\n    .MuiOutlinedInput-root {\n        & fieldset {\n            border-color: $light-gray;\n        }\n        &:hover fieldset {\n            border-color: $dark-gray;\n        }\n        &.Mui-focused fieldset {\n            border-color: $primary-color;\n        }\n    }\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 1.5rem;\n    .cancel-button {\n        color: #555;\n        text-transform: none;\n    }\n    .save-button {\n        background-color: $primary-color;\n        color: #fff;\n        border-radius: 8px;\n        padding: 8px 16px;\n        box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n        text-transform: none;\n        &:hover {\n            background-color: darken($primary-color, 10%);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
